import { render, staticRenderFns } from "./MbGuidaWidget.vue?vue&type=template&id=3e5b51fc&"
import script from "./MbGuidaWidget.vue?vue&type=script&lang=js&"
export * from "./MbGuidaWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports